export const SP_LIST_NAME_EMBEDDINGS = 'WV_SearchEmbeddingsCache';
export const SP_LIST_NAME_CORE_SETTINGS = 'WVHealth_CoreSettings';

export const SP_LIST_NAME_INJIO_REGISTRY = 'InjioSearchRegistry';
export const SP_INJIO_EMBEDDINGS_LIST_PREFIX = 'InjioEmbeddings-';

export const SEARCH_INDEX_STALE_DAYS = 7;
export const SEARCH_INDEX_REGEN_DAYS = 30;
export const SEARCH_INDEX_LEASE_TTL_MS = 150_000;
export const SEARCH_INDEX_LEASE_HEARTBEAT_MS = 60_000;

// Minimum number of newly-indexed/regenerated items a run must have processed before
// IndexProgressPanel's "no extractable content" warning is shown. Below this, a 100%
// no-content rate is just as likely to be a handful of genuinely thin pages as a
// systemic extraction problem, so warning on it would be a false alarm.
export const SEARCH_INDEX_NO_CONTENT_WARNING_MIN_ITEMS = 5;

// Auto sign-out after this much inactivity; the warning dialog appears
// IDLE_WARNING_MS before the deadline with a live countdown.
export const IDLE_TIMEOUT_MS = 30 * 60_000;
export const IDLE_WARNING_MS = 60_000;

